import { Component } from "react";

import BCService from "../../../services/BC";
import ChequePayementDetail from "./ChequePayementDetail";
import EnlignePayementDetail from "./EnlignePayementDetail";
import EspecePayementDetail from "./EspecePayementDetail";
import VirementPayementDetail from "./VirementPayementDetail";
import SellingService from "../../../services/SellingService";

class ListAvancePayementBC extends Component {
  state = {
    alert_message: "",
    avancePayements: [],
  };
  constructor(props) {
    super(props);

    this.state = {
      alert_message: "",
      avancePayements: [],
    };
  }
  componentDidMount() {
    this.forceUpdate();
    if (localStorage.getItem("isIncome")  === "ACHAT") {
      BCService.getListAvancePayementBDC(this.props.idBC)
        .then((response) => {
          console.log(response);

          if (response.data["vide"] === "No data") {
            this.setState({ alert_message: "error" });
          } else {
            this.setState({
              avancePayements: response.data["success"].payementInformationBDC,
            });
            console.log(response.data["success"].payementInformationBDC);

            this.setState({ alert_message: "success" });
          }
        })
        .catch((error) => {
          this.setState({ alert_message: "error" });
        });
    } else if (localStorage.getItem("isIncome")  === "VENTE") {
      SellingService.getListAvancePayementBDC(this.props.idBC)
        .then((response) => {
          console.log(response);
          if (response.data["vide"] === "No data") {
            this.setState({ alert_message: "error" });
          } else {
            this.setState({
              avancePayements: response.data["success"].payementInformationBDC,
            });
            console.log(response.data["success"].payementInformationBDC);

            this.setState({ alert_message: "success" });
          }
        })
        .catch((error) => {
          this.setState({ alert_message: "error" });
        });
    }
  }
  formatDate(date) {
    var cdate = new Date(date);
    var day = String(cdate.getDate()).padStart(2, "0");
    let month = String(cdate.getMonth()).padStart(2, "0");
    let year = cdate.getFullYear();
    return day + "/" + month + "/" + year;
  }
  payementDetails(payementAvance) {
    if (payementAvance.typePayement === "Espéce") {
      return <EspecePayementDetail payementAvance={payementAvance} />;
    } else if (payementAvance.typePayement === "En ligne") {
      return <EnlignePayementDetail payementAvance={payementAvance} />;
    } else if (payementAvance.typePayement === "Chéque / Traites") {
      return <ChequePayementDetail payementAvance={payementAvance} />;
    } else if (payementAvance.typePayement === "Virement") {
      return <VirementPayementDetail payementAvance={payementAvance} />;
    }
  }

  render() {
    if (this.state.alert_message === "error") {
      return <div class="col-12"></div>;
    } else {
      return (
        <div class="row">
          <div className="col-12">
            <div className="card ">
              <div className="card-header">
                <h3 className="card-title">
                  Les avances des payements sur le bon de commande
                </h3>
              </div>
              <div className="card-body">
                {this.state.avancePayements.map((payementAvance) => (
                  <div className="post ">
                    {this.payementDetails(payementAvance)}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
export default ListAvancePayementBC;
